import React, { useState } from "react"

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from "reactstrap"

import { SectionIncome, SectionEducation, SectionEmployment } from "../county"
import classnames from "classnames"

const SectionRatings = ({ county }) => {
  const [activeTab, setActiveTab] = useState("1")

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const higherRatings = ["A+", "A", "A-", "B+", "B", "B-"]

  const renderRating = (rating, ratingLabel) => {
    return (
      <div className="d-flex justify-content-center align-items-center flex-column">
        <div
          className={
            higherRatings.includes(rating)
              ? "rating-circular-card"
              : "rating-circular-card-low"
          }
        >
          {rating ? rating : "X"}
        </div>
        <h5 className="all-rating-text">{ratingLabel}</h5>
      </div>
    )
  }

  return (
    <section id="ratings">
      <Container className="mt-5">
        <h2 className="title mb-4">Neighborhood Rating</h2>
        <p className="text-muted">
          Before you make your next big investment, make sure to do your
          research on the neighborhood with Real Estate Market Insight. Get a
          sense of the property values and crime rates of your potential
          investment area. We rate the neighborhood based on a variety of
          factors such as income, education, employment, and poverty. Then take
          the average of those ratings to arrive at an overall rating. The
          neighborhood ratings for{" "}
          <span className="text-primary fw-bold">{` ${county.county}, ${county.state} `}</span>
          are listed below.
        </p>
      </Container>
      <Container className="mt-5 mb-5">
        <Row>
          <Col md={6} xs={12} className="main-rating">
            <div className="d-flex justify-content-start align-items-center">
              <div
                className={
                  higherRatings.includes(county.rating.overall_score)
                    ? "rating-card"
                    : "rating-card-low"
                }
              >
                {county.rating.overall_score === "NaN"
                  ? "X"
                  : county.rating.overall_score}
              </div>
              <h5 className="main-rating-text">Overall Rating</h5>
            </div>
          </Col>
          <Col
            md={6}
            xs={12}
            className="d-flex justify-content-between align-items-center all-ratings"
          >
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => {
                    toggle("1")
                  }}
                >
                  {renderRating(county.rating.income_rating, "Income")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => {
                    toggle("2")
                  }}
                >
                  {" "}
                  {renderRating(county.rating.edu_rating, "Education")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => {
                    toggle("3")
                  }}
                >
                  {" "}
                  {renderRating(county.rating.employment_rating, "Employment")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "4" })}
                  onClick={() => {
                    toggle("4")
                  }}
                  disabled={true}
                >
                  {" "}
                  {renderRating(county.rating.business_rating, "Business")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "5" })}
                  onClick={() => {
                    toggle("5")
                  }}
                  disabled={true}
                >
                  {" "}
                  {renderRating(county.rating.poverty_rating, "Poverty")}
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <Row>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <SectionIncome county={county} />
            </TabPane>
            <TabPane tabId="2">
              <SectionEducation county={county} />
            </TabPane>
            <TabPane tabId="3">
              <SectionEmployment county={county} />
            </TabPane>
          </TabContent>
        </Row>
      </Container>
    </section>
  )
}

export default SectionRatings
